import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { SmartintegService } from '../../../../services/smartinteg.service';
import { ToastService } from '../../../../services/toast.service';
import { Processo, ExecutarProcessoResult, LogExecucao } from '../../../../types/smartinteg';
import { Message } from 'primeng/api';

@Component({
  selector: 'app-processo-executor',
  templateUrl: './processo-executor.component.html',
  styleUrls: ['./processo-executor.component.css']
})
export class ProcessoExecutorComponent implements OnInit {

  processoId!: string;
  processo: Processo | null = null;
  loading: boolean = true;
  executando: boolean = false;

  resultado: ExecutarProcessoResult | null = null;
  logs: Message[] = [];

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private smartintegService: SmartintegService,
    private toastService: ToastService
  ) { }

  ngOnInit(): void {
    this.processoId = this.route.snapshot.paramMap.get('processoId')!;
    if (this.processoId) {
      this.carregarProcesso();
    } else {
      this.toastService.erro('Erro', 'ID do processo não encontrado.');
      this.voltar();
    }
  }

  carregarProcesso(): void {
    this.loading = true;
    this.smartintegService.buscarProcesso(this.processoId).subscribe({
      next: (data) => {
        this.processo = data;
        this.loading = false;
      },
      error: (err) => {
        this.toastService.erro('Erro', 'Falha ao buscar dados do processo.');
        this.loading = false;
      }
    });
  }

  executar(): void {
    this.executando = true;
    this.resultado = null;
    this.logs = [];
    this.logs.push({ severity: 'info', summary: 'Iniciando', detail: `Execução do processo '${this.processo?.nome}' iniciada...` });

    this.smartintegService.executarProcesso(this.processoId).subscribe({
      next: (res) => {
        this.resultado = res;
        this.formatarLogs(res.logs);
        if (res.sucesso) {
          this.toastService.sucesso('Sucesso', res.mensagem || 'Processo concluído.');
        } else {
          this.toastService.alerta('Atenção', res.mensagem || 'Processo concluído com avisos.');
        }
        this.executando = false;
      },
      error: (err) => {
        this.toastService.erro('Erro', 'Falha na execução do processo.');
        this.logs.push({ severity: 'error', summary: 'Erro Crítico', detail: err.error?.message || 'Ocorreu um erro inesperado.' });
        this.executando = false;
      }
    });
  }

  formatarLogs(logs: LogExecucao[]): void {
    this.logs = logs.map(log => ({
      severity: log.nivel.toLowerCase(),
      summary: log.recurso || 'Geral',
      detail: `[${new Date(log.timestamp).toLocaleTimeString()}] ${log.mensagem}`
    }));
  }

  voltar(): void {
    this.router.navigate(['/smartinteg/processos']);
  }
}
